"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/mattsson/mattsson.scss');
const index_1 = require("./../js/index");
const mattsson_1 = require("./../js/Sites/mattsson");
const ProductsApp_mattsson_1 = require("./ReactComponents/Products/ProductsApp-mattsson");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Initialize Mattsson specific scripts
(0, mattsson_1.InitMattsson)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)(Object.assign(Object.assign({}, index_1.DefaultComponentTypes), { ProductsApp: ProductsApp_mattsson_1.default }));
